<template>
  <BaseDataTable
    v-if="documents.length > 0"
    :headers="tableHeaders"
    :items="documents"
    hide-default-footer
    class="document-data-table"
    v-model="filesSelectable"
    show-select
    item-key="arquivo.nome"
  >
    <template v-slot:[`item.arquivo.nome`]="{ item }">
      <div class="d-flex">
        <v-icon class="primary--text pr-4">fa-file-pdf</v-icon>
        <span class="truncate">{{ nameFile(item) }}</span>
      </div>
    </template>
    <template v-slot:[`item.actions`]="{ item }">
      <div class="d-flex justify-end">
        <BaseButton
          color="secondary"
          class="base-input-file__button mr-2 px-0"
          @click="$emit('preview-file', item)"
        >
          <img :src="require('@/assets/ic_eye.svg')" />
        </BaseButton>
        <BaseButton
          color="secondary"
          class="base-input-file__button px-0"
          @click="$emit('remove-file', item)"
          v-if="deleteButton && !disabled"
        >
          <img :src="require('@/assets/ic_trash.svg')" />
        </BaseButton>
      </div>
    </template>
  </BaseDataTable>
</template>

<script>
const tableHeaders = [
  { text: "Anexos", value: "arquivo.nome", sortable: false },
  { text: "Ações", value: "actions", sortable: false }
];

export default {
  name: "DocumentDataTable",
  data() {
    return { tableHeaders };
  },
  computed: {
    filesSelectable: {
      get() {
        return this.selectable;
      },
      set(value) {
        this.$emit("selectable", value);
      }
    }
  },
  methods: {
    nameFile(item) {
      return (item.arquivo && item.arquivo.nome) || item.nome;
    }
  },
  props: {
    documents: { type: Array },
    deleteButton: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    selectable: {
      type: Array
    }
  }
};
</script>
<style lang="sass">
.document-data-table
  thead tr th:last-child
    text-align: end !important
</style>
